export default __webpack_public_path__ + "static/media/documentImageColor.7f2f9d48.svg";